import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { ToolTipNotificationComponent } from '../../form-elements/tool-tip-notification/tool-tip-notification.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-text-only',
    templateUrl: './text-only.component.html',
    styleUrls: ['./text-only.component.scss'],
    imports: [ReactiveFormsModule, NgClass, ToolTipNotificationComponent]
})
export class TextOnlyComponent {

  @Input() question : LifeStyleQuestion;
  @Input() parent :  UntypedFormGroup;
  @Input() controlName : string;
  @Input() pageName: string;
  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() displayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: UntypedFormBuilder) { }


  
  initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  displayMobileTooltipReceiver(){
    this.displayMobileTooltipEmitter.emit();
  }
}
